const Categories = require('../model/Categories');
const ChannelDefinition = require('../model/ChannelDefinition');
const Requirements = require('../model/Requirements');

class SearchWidgetChannel extends ChannelDefinition {
	id = 'search-widget';
	title = 'Search Widget';
	description = 'Allow website customers to quickly search in-store stock for any location.';
	category = Categories.OMNICHANNEL_EXPERIENCE;

	iconUrl = 'https://go.near.st/hubfs/channels/nearst.png';
	coverImageUrl = 'https://go.near.st/hubfs/channels/headers/search-widget.png';

	longDescription = `
## Overview
The Search widget is designed to be embedded on your website, allowing customers to search your in-store products.

## How it works
Embedding the widget in your website is very easy and only requires a few lines of code. It enables your customers to search for products that you have in-store.


## Requirements
- Website
- An active Google Storefront 
	`;

	manageUrl = '/channels/{shopId}/settings/search-widget';
	productSpecificVisibility = false;

	worksWith = ['google'];

	helpArticleUrls = [
		{
			title: 'Adding the search widget',
			url: 'https://support.near.st/en/articles/6679923-how-to-add-the-nearst-search-widget-to-your-website'
		}
	];

	requirements = new Requirements({
		plans: ['standard', 'advanced']
	});
}

module.exports = SearchWidgetChannel;
